/** @description 增值包权限 */
enum USER_PERMISSION_KEY {
  /* 导出样式二孔槽图DXF */
  EXPORT_THE_STYLE_TWO_HOLE_SLOT_DIAGRAM_DXF = 'CAD_hole_slot_diagram',
  /* 余料回收站 */
  SURPLUS_RECYCLE_BIN = 'surplus_recycle_bin',
  /** 高级异形嵌套 */
  ADVANCED_IRREGULAR_NESTING = 'advanced_nesting',
  /** 文件夹自定义 */
  CUSTOM_FOLDER = 'customize_folder',
  /** 创建排版任务 */
  CREATE_PAIBAN_TASK = 'layout_task',
  /** 对纹 */
  PANEL_GRAIN_ALIGN = 'panel_grain_align',
  /** 大板厚度标识 */
  BIG_PLANK_THICK_MARK = 'big_plank_thick_mark',
  /** 二次加工 */
  SECONDARY_PROCESSING = 'secondary_processing',
  /** 小板副标签 */
  SECONDARY_LABEL = 'secondary_label',
  /** 深度计算 */
  DEEP_SEARCH = 'deep_computing',
}
/** @description 增值包权限对应文案 */
enum USER_PERMISSION_TIP {
  /* 导出样式二孔槽图DXF */
  EXPORT_THE_STYLE_TWO_HOLE_SLOT_DIAGRAM_DXF = '导出样式二孔槽图DXF',
  /* 余料回收站 */
  SURPLUS_RECYCLE_BIN = '余料回收站',
  /** 高级异形嵌套 */
  ADVANCED_IRREGULAR_NESTING = '高级异形嵌套',
  /** 对纹 */
  PANEL_GRAIN_ALIGN = '板件对纹',
  /** 文件夹自定义 */
  CUSTOM_FOLDER = '文件夹自定义',
  /** 创建排版任务 */
  CREATE_PAIBAN_TASK = '创建排版任务',
  /** 大板厚度标识 */
  BIG_PLANK_THICK_MARK = '大板厚度标识',
  /** 二次加工 */
  SECONDARY_PROCESSING = '二次加工',
  /** 小板副标签 */
  SECONDARY_LABEL = '小板副标签',
  /** 深度计算 */
  DEEP_SEARCH = '深度计算',
}

export { USER_PERMISSION_KEY, USER_PERMISSION_TIP }
